module.exports = __webpack_public_path__ + "img/error.f7ea6e19.svg";